import { getProviders } from '@/graphql/queries/shared/institution';
import lang from '@/lang/middleware/products/protection/life-insurance';

export default async ({ $apolloQuery, store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const coverType = store.getters['products/getCoverType'];
  await $apolloQuery(getProviders, { product: coverType.api }).then(providers => {
    const description = store.$i18n.t('providers.description', { coverType: coverType.name });
    const subtitle = store.$i18n.t('providers.subtitle', { coverType: coverType.name });
    const title = store.$i18n.t('providers.title', { coverType: coverType.name });
    store.commit('jumbotron/SET_JUMBOTRON', { subtitle, title, type: 'generic' });
    store.commit('pageContent/SET_DYNAMIC_BREADCRUMBS', [
      ['i18n/home', '/'], ['i18n/insurance', '/insurance/'], [`i18n/${coverType.scope}`, `/${coverType.path}/`], 'i18n/providers'
    ]);
    store.commit('pageContent/setHead', { description, title });
    store.commit('providers/setList', providers);
  });
};
